import { render } from "./NavbarElement.vue?vue&type=template&id=47793324&scoped=true"
import script from "./NavbarElement.vue?vue&type=script&lang=js"
export * from "./NavbarElement.vue?vue&type=script&lang=js"

import "./NavbarElement.vue?vue&type=style&index=0&id=47793324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47793324"]])

export default __exports__